<template>
  <v-dialog v-if="items.length > 0" scrollable :value="value" width="800px" @input="$emit('input', $event)">
    <v-card class="selected-items-dialog">
      <v-card-title class="pa-3">
        <h3 class="dialog-title px-3">Produtos selecionados ({{ items.length }})</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <recycle-scroller v-slot="{ item, index }" class="vue-recycle-scroller scroller ready direction-vertical" :items="items" :item-size="45" key-field="id">
          <div class="product">
            {{ item.id }} - {{ item.name }}
            <v-spacer></v-spacer>
            <mf-button type="icon" icon="close" color="cinza-0" @click="removeProduct(item, index)" />
          </div>
        </recycle-scroller>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <mf-button class="mr-3" text label="Cancelar" @click="$emit('input', false)" />
        <export-data :data-fetcher="exportCsv" filename="Arvore de produtos" @exportFinishedSuccessfully="$emit('input', false)" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: {
    RecycleScroller,
    ExportData: () => import('@/components/export-data/ExportData.vue'),
  },
  props: {
    value: Boolean,
    items: Array,
  },
  methods: {
    exportCsv() {
      let maxPathSize = 0
      const productsToExport = this.items.map((product) => {
        const baseProduct = {
          id: product.id,
          name: product.name,
          cod_barras: product.codBarras,
        }
        maxPathSize = product.categoriesPath.length > maxPathSize ? product.categoriesPath.length : maxPathSize
        product.categoriesPath.forEach((category, index) => {
          baseProduct[`categoria_${index + 1}_id`] = category.id
          baseProduct[`categoria_${index + 1}_nome`] = category.name
        })
        return baseProduct
      })
      const headers = ['id', 'nome', 'cod_barras']
      Array.from(Array(maxPathSize).keys()).forEach((index) => {
        headers.push(`categoria_${index + 1}_id`)
        headers.push(`categoria_${index + 1}_nome`)
      })
      const rows = productsToExport.map((product) => {
        const row = [product.id, product.name, product.cod_barras]
        Array.from(Array(maxPathSize).keys()).forEach((index) => {
          row.push(product[`categoria_${index + 1}_id`])
          row.push(product[`categoria_${index + 1}_nome`])
        })
        return row
      })
      return { headers, rows }
    },
    removeProduct(item, index) {
      this.$emit('remove-product', { item, index })
    },
  },
}
</script>

<style lang="scss">
.selected-items-dialog {
  .dialog-title {
    font-size: 22px;
    font-weight: normal;
  }
  .scroller {
    height: 100%;
  }
  .product {
    height: 45px;
    padding: 0 12px;
    display: flex;
    align-items: center;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
  }
}
</style>
